import {
  PauseCircleMajor,
  PlayCircleMajor,
  ReplayMinor,
} from "@shopify/polaris-icons";
import { useEffect } from "react";

export interface StoryPlayPauseProps {
  secondsPerSlide: number;
  nextHref: string | null;
  playing: boolean;
  longPressing: boolean;
  isLastSlide: boolean;
  onPlay: () => void;
  onPause: () => void;
  onAdvance?: () => void;
  onRestart: () => void;
}

export function StoryPlayPause({
  secondsPerSlide,
  nextHref,
  playing,
  longPressing,
  isLastSlide,
  onPlay,
  onPause,
  onAdvance,
  onRestart,
}: StoryPlayPauseProps) {
  useEffect(() => {
    if (isLastSlide || !playing || longPressing || !onAdvance) {
      return;
    }

    const interval = setInterval(() => {
      onAdvance();
    }, secondsPerSlide * 1_000);

    return () => {
      clearInterval(interval);
    };
  }, [
    playing,
    nextHref,
    longPressing,
    secondsPerSlide,
    isLastSlide,
    onAdvance,
  ]);

  return (
    <button
      tabIndex={0}
      type="button"
      aria-label={playing ? "playing" : "paused"}
      data-test-id="story-play-pause"
      className="lookbook--story--playpause"
      onClick={isLastSlide ? onRestart : playing ? onPause : onPlay}>
      {isLastSlide ? (
        <div className="lookbook--story--playpause--replay-button">
          <ReplayMinor fill="currentColor" />
        </div>
      ) : playing && !longPressing ? (
        <PauseCircleMajor fill="currentColor" />
      ) : (
        <PlayCircleMajor fill="currentColor" />
      )}
      {!isLastSlide && playing && !longPressing ? (
        <svg
          className="lookbook--story--playpause--countdown-circle"
          // this key tells react to render a new element when the page changes, which restarts the CSS animations
          key={nextHref}
          viewBox="0 0 100 100">
          <circle
            cx="50"
            cy="50"
            r="45"
            style={{ animationDuration: `${secondsPerSlide}s` }}
          />
        </svg>
      ) : null}
    </button>
  );
}
